import type { Config } from "@killiangabrielkamae/cryptr-react"
import { AuthProviderProps } from "react-oidc-context"

type NODE_ENV = "production" | "development"

const config = {
  env: (import.meta.env.DEV ? "development" : "production") as NODE_ENV,
  api: import.meta.env.VITE_REACT_APP_API_URL ?? "https://api.kamae.io",
  app: import.meta.env.VITE_REACT_APP_APP_URL ?? "https://app.kamae.io",
  // Fallback to PostHog Test project
  posthogKey: import.meta.env.VITE_REACT_APP_POSTHOG_KEY ?? "phc_8VrHwQadmAII7pU9v5qhDHskVtMfQ0LjBobnLV4rHQ0",
  // Fallback to Intercom Test project
  intercomKey: import.meta.env.VITE_REACT_APP_INTERCOM_KEY ?? "we22i5ih",
  kamae: "https://kamae.fr",
  kamaeEssentialUrl: "https://kamae.fr/axa-offre-kamae-essential/",
  dash0AuthToken: import.meta.env.VITE_DASH0_TOKEN ?? "auth_gfNA5qqwxkufYo3TYZOsa7V03h8PqQwm",
}

export const auth0Config = {
  login: import.meta.env.VITE_REACT_APP_AUTH0_URL,
  loginDomain: import.meta.env.VITE_REACT_APP_AUTH0_DOMAIN,
  clientId: import.meta.env.VITE_REACT_APP_AUTH0_CLIENT_ID,
}

// tag::CRYPTR_CONF[]
export const cryptrConf: Config = {
  // Root URL of our front app
  audience: config.app,

  // Reference to our front app id
  client_id: import.meta.env.VITE_REACT_APP_CRYPTR_CLIENT_ID ?? "3227c76a-0de5-47c8-b9ef-d37f86bd67ec",

  // Desired redirection URL after authentication process
  default_redirect_uri: config.app,

  // Did we have a dedicated server in Cryptr
  dedicated_server: true,

  // Defines if SLO (Single Logout) has to be done on SSO logout process
  default_slo_after_revoke: false,

  // URL of our Cryptr service
  cryptr_base_url: "https://kamae.authent.me",

  // Reference to our company entity
  tenant_domain: "kamae",
}
// end::CRYPTR_CONF[]

// tag::AXA_OIDC_CONF[]
export const axaOidcConf: AuthProviderProps = {
  authority:
    import.meta.env.VITE_REACT_APP_AXA_OIDC_URL ??
    "https://login.microsoftonline.com/f3ede3e2-160d-4865-b6ea-50f6453466fa",
  client_id: import.meta.env.VITE_REACT_APP_AXA_CLIENT_ID ?? "516317d2-1732-4d83-b009-6c80c5a8f2ca",
  redirect_uri: import.meta.env.VITE_REACT_APP_AXA_REDIRECT_URL ?? "http://localhost:3000/login",
  scope: "openid profile email",
}
// end::AXA_OIDC_CONF[]

export default config
